import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { TranslateService } from 'ngx-translate-with-country';
import { DOCUMENT } from '@angular/common';
import { appsettings } from '../shared/app.settings';

@Injectable()
export class LocationService {

  //   private locations: Observable<any[]>;

  ipAddress: string;
  country: any;
  locations: any;
  countryCode: any;
  langCode: any;
  countryLanguage: any;
  mainLang: any;
  languageCode: any;

  public socialMediaArray: any;
  public socialMediaElements: any;
  public socialMediaItems: any;

  constructor(
    private http: HttpClient,
    private router: Router,
    private translate: TranslateService,
    @Inject(DOCUMENT) private _document: any
  ) { }

  getLocations() {
    console.log("burda")
    return this.http
      .get(appsettings.rootUrl + 'eu/en/locations')
      .map(
        (locations) => {
          return locations;
        });
  }

  getRegisterCountries(country = 'eu', language = 'en') {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/registercountries')
      .map(locations => {
        return locations;
      });
  }

  getLocation(country = 'eu', language = 'en') {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/locations')
      .map(locations => {
        return locations;
      });
  }

  public getCountryFromIp(ip: string) {
    return this.http
      .get('https://ipinfo.io/' + ip, {
        params: {
          token: "803c50dffd63b2"
        },
      })
      .map(
        (country) => {
          return country['country'];
        });
  }

  public getSocialMedia(country: string = 'eu', language: string = 'en') {
    return this.http
      .get(appsettings.rootUrl + country + '/' + language + '/socialmedia')
      .map(
        (socialmedia) => {
          return socialmedia;
        });
  }

  public getIpAddress() {
    return this.http
      .get('https://ipinfo.io/', {
        params: {
          token: "803c50dffd63b2"
        },
      })
      .map(
        (ipAddress) => {
          return ipAddress['ip'];
        })
      .subscribe(
        ipArray => {
          this.ipAddress = ipArray;
          this.country = this.getCountryFromIp(this.ipAddress)
            .subscribe(
              ipAddressArray => {
                this.country = ipAddressArray.toLowerCase();
                this.getLocation()
                  .subscribe(
                    resultArray => {
                      this.locations = resultArray;
                      this.countryCode = this.locations.filter(
                        location => location.code === this.country
                      );

                      this.languageCode = this.countryCode.map(
                        (language) => {
                          language.lang.map(
                            (main) => {
                              if (main.main === 1) {
                                this.langCode = main.code;
                              }
                            }
                          );
                        }
                      );

                      if (!Array.isArray(this.countryCode) || !this.countryCode.length) {
                        this.countryLanguage = 'eu/en';
                        this.country = 'eu';
                        this.langCode = 'en';
                      } else {
                        this.countryLanguage = this.countryCode[0].code + '/' + this.langCode;
                        this.country = this.countryCode[0].code;
                      }

                      this.router.navigate(['/' + this.countryLanguage]);
                      this.translate.use(this.langCode, this.country);
                      this.translate.onLangChange.map(x => x.lang)
                        .subscribe(lang => this._document.documentElement.lang = lang);

                    },
                    error => {
                      this.countryLanguage = 'eu/en';
                      this.country = 'eu';
                      this.langCode = 'en';
                      this.router.navigate(['/' + this.countryLanguage]);
                      this.translate.use(this.langCode, this.country);
                      this.translate.onLangChange.map(x => x.lang)
                        .subscribe(lang => this._document.documentElement.lang = lang);
                    }
                  );
              },
              error => {
                this.countryLanguage = 'eu/en';
                this.country = 'eu';
                this.langCode = 'en';
                this.router.navigate(['/' + this.countryLanguage]);
                this.translate.use(this.langCode, this.country);
                this.translate.onLangChange.map(x => x.lang)
                  .subscribe(lang => this._document.documentElement.lang = lang);
              }
            );
        },
        error => {
          this.countryLanguage = 'eu/en';
          this.country = 'eu';
          this.langCode = 'en';
          this.router.navigate(['/' + this.countryLanguage]);
          this.translate.use(this.langCode, this.country);
          this.translate.onLangChange.map(x => x.lang)
            .subscribe(lang => this._document.documentElement.lang = lang);
        }
      );
  }

  getSocialMediaArray() {
    return this.socialMediaElements;
  }

}
